import Handlebars from "handlebars";
import {t} from "@lingui/core/macro";

export default () => Handlebars.compile(`<div class="empty-badge-picker">
<div style="font-size:180%">${t`No badges...yet!`}</div>
${t`<a href="/">Practice a skill</a> or <a href="/library">watch a video</a> to earn your first badge.`}
</div>`) as any;
